import { createSelector } from "reselect";

import { EMPTY_OBJECT } from "lib";

import { getSaleyardName } from "lib/navigation";

import { createIdByKeySelector } from "./lib";
import { getSaleyards } from "./root";
import { SaleType } from "constants/sale";

// FIXME - this will only re-fire on change of STATE (ANY changes of state, but, still) as compared to any change of
// saleyard.
export const selectCurrentSaleyard = createSelector(
  [getSaleyards, () => getSaleyardName()],
  (saleyards, saleyardName) => {
    return (
      Object.values(saleyards).find(
        saleyard => saleyard.name === saleyardName,
      ) || EMPTY_OBJECT
    );
  },
);

export const selectSaleyardNameBySaleyardIdLookup = createIdByKeySelector(
  getSaleyards,
  "id",
  "name",
);

const selectSaleyardIdBySaleTypeLookup = createSelector(
  [getSaleyards],
  saleyards => {
    return Object.values(saleyards).reduce((acc, saleyard) => {
      // If there's a saleyard with the same name as a sale type - do that.
      if (Object.values(SaleType).includes(saleyard.name)) {
        acc[saleyard.name] = saleyard.id;
      }
      return acc;
    }, {});
  },
);

export const getSaleyardIdBySaleType = saleType => state =>
  selectSaleyardIdBySaleTypeLookup(state)[saleType] || null;
